import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslations } from "use-intl";

import { Skeleton } from "@lawline/ui/components/skeleton";

import { adminUsersQueryOptions } from "./users.queries";
import { TableSearch } from "@platform/components/ui/table-search";
import { UsersTable } from "./components/users-table";

export function AdminUsersPage() {
	const t = useTranslations("admin.users");
	const { data: users, isPending, error } = useQuery(adminUsersQueryOptions);
	const [query, setQuery] = useState("");

	const q = query.trim().toLowerCase();
	const visible = q
		? (users ?? []).filter(
				(u) => u.name.toLowerCase().includes(q) || u.email.toLowerCase().includes(q),
			)
		: (users ?? []);

	return (
		<section className="mx-auto mt-2 flex w-full max-w-3xl flex-col gap-6">
			<h1 className="text-2xl font-semibold">{t("title")}</h1>

			{isPending ? (
				<Skeleton className="h-24 w-full" />
			) : error ? (
				<p className="text-destructive text-sm">{t("error")}</p>
			) : (
				<div className="flex flex-col gap-3">
					<TableSearch value={query} onChange={setQuery} placeholder={t("searchPlaceholder")} />
					<UsersTable users={visible} />
				</div>
			)}
		</section>
	);
}
